import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './usedbytesSearchController.json';

const usedbytesSearchController = (req, res, ctx) => {
  const scenario = req.body && req.body.path;
  const responseData =
    apiResponses['usedbytesSearchController/initUsedBytesInfo'].success[scenario] ||
    apiResponses['usedbytesSearchController/initUsedBytesInfo'].success.default;

  return res(ctx.json(mockResponse(responseData)));
};

export const handlers = [
  rest.post(
    getApiEndpoint('usedbytesSearchController/initUsedBytesInfo'),
    withScenario(withAuthCheck(usedbytesSearchController))
  ),
];
